import React from 'react';
import {
  FDBox, FDStack, FDIcon, FDSecondaryActionButton,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  EstatePlanningC2BWrapper,
} from 'Views/Page/Content/Modal/Layouts/EstatePlanningC2BLayouts/components/EstatePlanningC2BWrapper';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { dispatchWizardFinishedRefresh } from 'Hooks/useRefreshEvent';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import InvitationLinkPicker
  from 'Views/Page/Content/Modal/Layouts/EstatePlanningC2BLayouts/EstatePlanningBuySuccess/Layout/InvitationLinkPicker/InvitationLinkPicker';

const EstatePlanningBuySuccessStepLayout = () => {
  const {
    clearModalCollection,
  } = useModalContext();
  const { resource } = useMetaLayoutContext();

  return (
    <EstatePlanningC2BWrapper>
      <FDBox paddingY={2}>
        <FDStack direction={'row'} alignItems={'center'} justifyContent={'flex-start'} spacing={2}>
          <FDIcon icon={'checkCircleIcon'} color={'success'} size={'xl'} />
          <MetaControlField attr={'successText'} />
        </FDStack>
      </FDBox>
      <MetaControlField
        attr={'subtitle'}
        hideEmptyFields
      />
      <MetaControlField attr={'body'} />
      <FDBox paddingY={2}>
        <FDStack direction={'row'} alignItems={'flex-start'} spacing={2}>
          <InvitationLinkPicker resource={resource} />
          <FDSecondaryActionButton
            onClick={async () => {
              clearModalCollection();
              dispatchWizardFinishedRefresh();
            }}
            label={'Finish'}
          />
        </FDStack>
      </FDBox>
    </EstatePlanningC2BWrapper>
  );
};

EstatePlanningBuySuccessStepLayout.defaultProps = {
};

EstatePlanningBuySuccessStepLayout.propTypes = {
};

export { EstatePlanningBuySuccessStepLayout };
